import { getApiPath } from "./ApiUtils";

export const sanitizeReturnTo = (
    value: string | null | undefined,
    fallback: string = "/"
): string => {
    if (!value?.startsWith("/") || value.startsWith("//")) return fallback;

    try {
        const target = new URL(value, window.location.origin);
        if (target.origin !== window.location.origin) return fallback;
        return `${target.pathname}${target.search}${target.hash}`;
    } catch {
        return fallback;
    }
};

export const getCurrentReturnTo = (): string => {
    const value = `${window.location.pathname}${window.location.search}${window.location.hash}`;
    return sanitizeReturnTo(value);
};

export const getAuthenticationLoginUrl = (returnTo: string): string => {
    const query = new URLSearchParams({ returnTo });
    return `${getApiPath("auth/login")}?${query.toString()}`;
};

export const getAuthenticationRegistrationUrl = (
    returnTo: string = "/"
): string => {
    const query = new URLSearchParams({ returnTo });
    return `${getApiPath("auth/register/start")}?${query.toString()}`;
};

export const getAuthenticationRegistrationRecoveryUrl = (
    returnTo: string = "/"
): string => {
    const query = new URLSearchParams({ returnTo });
    return `${getApiPath("auth/register/continue")}?${query.toString()}`;
};
